import apiService from '../Api'
import { Machine, MachineActivationResponse, MachinesFilter, MachinesListResponse } from './types'

export class MachineService {
  async list(filter: Partial<MachinesFilter>): Promise<MachinesListResponse> {
    return apiService.get('/machines', { params: filter }).then((response) => response.data)
  }

  async create(name: string): Promise<MachineActivationResponse> {
    return apiService.post('/machines', { name, device_type: 'terminal' }).then((response) => response.data)
  }

  async reauthenticate(id: number): Promise<MachineActivationResponse> {
    return apiService.post(`/machines/${id}/reauthenticate`).then((response) => response.data)
  }

  async update(id: number, name: string): Promise<Machine> {
    return apiService.patch(`/machines/${id}`, { name }).then((response) => response.data)
  }

  async deactivate(id: number): Promise<void> {
    await apiService.patch(`/machines/${id}/deactivate`)
  }
}
